import { render, staticRenderFns } from "./ResourceControl.vue?vue&type=template&id=32e0f9b6&scoped=true"
import script from "./ResourceControl.vue?vue&type=script&lang=js"
export * from "./ResourceControl.vue?vue&type=script&lang=js"
import style0 from "./ResourceControl.vue?vue&type=style&index=0&id=32e0f9b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e0f9b6",
  null
  
)

export default component.exports